import { render, staticRenderFns } from "./SignedUp.vue?vue&type=template&id=2fdc098d&"
import script from "./SignedUp.vue?vue&type=script&lang=js&"
export * from "./SignedUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports